const getDate = ( date ) => {
	const year = date.getFullYear();
	const month = date.getMonth() + 1;
	const day = date.getDate();

	return `${ year }/${ month }/${ day }`;
};

const visited = localStorage.getItem( 'visited' );

if ( visited === null ) {
	const date = new Date();
	localStorage.setItem( 'visited', getDate( date ) );

	document.defaultView.addEventListener( 'DOMContentLoaded', () => {
		document.getElementById( 'js-transition__upper' ).style.display =
			'flex';
	} );
} else {
	const today = new Date();
	const visitedDate = new Date( visited );
	visitedDate.setDate( visitedDate.getDate() + 7 );

	if ( getDate( visitedDate ) <= getDate( today ) ) {
		document.defaultView.addEventListener( 'DOMContentLoaded', () => {
			document.getElementById( 'js-transition__upper' ).style.display =
				'flex';
		} );
	} else {
		document.defaultView.addEventListener( 'DOMContentLoaded', () => {
			document.getElementById( 'js-transition__upper' ).style.display =
				'none';
			document.getElementById( 'js-transition__upper' ).style.transition =
				'0s';
		} );
	}

	localStorage.setItem( 'visited', getDate( today ) );
}

setTimeout( () => {
	document.body.classList.remove( 'js-transition' );
}, 2000 );
